import { ProblemTemplate } from "app/models/problemTemplate";
import { ServiceObject } from "app/models/serviceObject";

export class CallOutputDTO {

    public id: number;
    public title: string;
    public description: string;
    public problemTemplateId: number;
    public serviceObjectId: number;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/dto/callOutputDTO.ts